<template>
  <div class="tabFilter">
    <!-- <item-selector
      id="hiddenTabsSelector"
      v-if="hiddenTabs.length"
      :available="toggleableTabs"
      v-model:active="hiddenTabs"
      title="Hidden Tabs"
    ></item-selector> -->
    <div v-if="hiddenTabs.length" class="hidden-tab-selector d-flex gap-4 p-2">
      <b>Hidden Tabs: </b>
      <div
        v-for="tab in toggleableTabs"
        :key="tab.value"
        class="d-flex align-items-center"
      >
        <input
          :id="`toggle-${tab.value}`"
          v-model="hiddenTabs"
          :value="tab.itemId"
          type="checkbox"
        />
        <label :for="`toggle-${tab.value}`" class="form-check-label">
          {{ tab.title }}
        </label>
      </div>
    </div>
    <ul class="list-unstyled list-inline tabFilter__filters">
      <li
        v-for="tab in computedTabs"
        :key="tab.label"
        :class="[
          'list-inline-item',
          'tabFilter__filter',
          { 'tabFilter--active': tab.label === tabStore.activeTab?.label },
        ]"
      >
        <button class="btn btn-link" type="button" @click="selectTab(tab)">
          {{ tab.label }}
        </button>
      </li>
    </ul>

    <DynamicComponents :components="[activeComponent]" />
  </div>
</template>

<script setup>
import { computed, onMounted, ref, watch } from "vue";
import { useTabStore } from "@apexl/icarus-core/src/store/useTabStore";
import DynamicComponents from "@apexl/icarus-core/src/components/partials/DynamicComponents.vue";

const props = defineProps({
  tabs: { type: Array, required: true },
  hiddenTabs: { type: Array, default: [] },
  components: { type: Array, required: true },
  persistActiveTab: { type: Boolean, default: true },
});

const tabStore = useTabStore();
const activeTab = computed(() => tabStore.activeTab);

const activeComponent = computed(
  () =>
    props.components.find(
      (component) => component.props.subEntity === activeTab.value?.value,
    ) || props.components[0],
);

if (props.persistActiveTab) {
  tabStore.enablePersistence();
}

const toggleableTabs = ref(
  props.hiddenTabs.map((tab) => ({ itemId: tab.value, title: tab.label })),
);

const hiddenTabs = ref(
  props.tabs
    .filter((tab) =>
      props.hiddenTabs.some((hiddenTab) => hiddenTab.value === tab.value),
    )
    .map((tab) => tab.value),
);

const computedTabs = computed(() => {
  return props.tabs.filter(
    (tab) => !hiddenTabs.value.some((value) => tab.value === value),
  );
});

watch(hiddenTabs, (newHiddenTabs, oldHiddenTabs) => {
  const newActiveTab = props.tabs.find(
    (tab) =>
      !newHiddenTabs.includes(tab.value) && oldHiddenTabs.includes(tab.value),
  );
  if (newActiveTab) {
    tabStore.setActiveTab(newActiveTab);
  } else if (props.tabs.length) {
    tabStore.setActiveTab(props.tabs[0]);
  }
});

onMounted(() => {
  if (
    hiddenTabs.value.includes(tabStore.activeTab?.value) ||
    !tabStore.activeTab
  ) {
    tabStore.setActiveTab(props.tabs[0]);
  }
});

function selectTab(tab) {
  tabStore.setActiveTab(tab);
}

const filteredComponents = ref(props.components);

watch(
  activeTab,
  (newTab) => {
    if (newTab) {
      // if (!props.hiddenTabs.some((hiddenTab) => hiddenTab.value === newTab.value)) {
      //   hiddenTabs.value.push(newTab.value);
      // }
      filteredComponents.value = props.components.filter(
        (component) => component.props?.subEntity === newTab.value,
      );
    } else {
      filteredComponents.value = props.components;
    }
  },
  { immediate: true },
);
</script>

<style lang="scss">
.tabFilter {
  &__filters {
    margin-bottom: 0;
  }

  &__filter {
    background-color: #6e7677;
    margin-right: 0 !important;
    border-right: 3px solid #888f90;

    &:last-child {
      border-right: none;
    }

    .btn-link {
      text-decoration: none;
      color: #fff;
    }

    &.tabFilter--active {
      background-color: #565656;
    }
  }
}

.hidden-tab-selector {
  background-color: #fff;
  border-top-left-radius: 0.25rem;
  border-top-right-radius: 0.25rem;
  margin-top: 1rem;

  input {
    margin-right: 0.25rem;
  }
}
</style>
